import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _get from "lodash/get";
import React, { useEffect, forwardRef, useState } from 'react';
import { SrLabel } from '~helpers';
import carouselPropTypes from '../prop-types/carouselPropTypes';
import DefaultSlider from './DefaultSlider';
import CarouselArrow from './CarouselArrow';
import CarouselDot from './CarouselDot';
import CarouselDotList from './CarouselDotList';
var Carousel = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var prevArrow = _ref.prevArrow,
      prevLabelId = _ref.prevLabelId,
      nextArrow = _ref.nextArrow,
      nextLabelId = _ref.nextLabelId,
      customPaging = _ref.customPaging,
      appendDots = _ref.appendDots,
      arrows = _ref.arrows,
      dotsType = _ref.dotsType,
      dotsPosition = _ref.dotsPosition,
      dotsAlignment = _ref.dotsAlignment,
      dotsOrientation = _ref.dotsOrientation,
      children = _ref.children,
      dots = _ref.dots,
      vertical = _ref.vertical,
      arrowSize = _ref.arrowSize,
      arrowType = _ref.arrowType,
      arrowCustomColor = _ref.arrowCustomColor,
      props = _objectWithoutPropertiesLoose(_ref, ["prevArrow", "prevLabelId", "nextArrow", "nextLabelId", "customPaging", "appendDots", "arrows", "dotsType", "dotsPosition", "dotsAlignment", "dotsOrientation", "children", "dots", "vertical", "arrowSize", "arrowType", "arrowCustomColor"]);

  var _useState = useState(vertical),
      isVertical = _useState[0],
      setIsVertical = _useState[1];

  var _useState2 = useState(dots),
      hasDots = _useState2[0],
      setHasDots = _useState2[1];

  var _useState3 = useState(arrows),
      hasArrows = _useState3[0],
      setHasArrows = _useState3[1];

  var _useState4 = useState(dotsPosition),
      hasDotsPosition = _useState4[0],
      setHasDotsPosition = _useState4[1];

  var _useState5 = useState(dotsAlignment),
      hasDotsAlignment = _useState5[0],
      setHasDotsAlignment = _useState5[1];

  var _useState6 = useState(dotsOrientation),
      hasDotsOrientation = _useState6[0],
      setHasDotsOrientation = _useState6[1];

  var carouselArrowNext = nextArrow || /*#__PURE__*/React.createElement(CarouselArrow, Object.assign({
    slide: "next",
    labelId: nextLabelId,
    vertical: isVertical,
    arrowSize: arrowSize,
    arrowType: arrowType,
    arrowCustomColor: arrowCustomColor
  }, props));
  var carouselArrowPrev = prevArrow || /*#__PURE__*/React.createElement(CarouselArrow, Object.assign({
    slide: "prev",
    labelId: prevLabelId,
    vertical: isVertical,
    arrowSize: arrowSize,
    arrowType: arrowType,
    arrowCustomColor: arrowCustomColor
  }, props));

  var carouseCustomPaging = customPaging || function (i) {
    return /*#__PURE__*/React.createElement(CarouselDot, {
      dotsType: dotsType
    }, /*#__PURE__*/React.createElement(SrLabel, {
      as: "span"
    }, i + 1));
  };

  var customAppendDots = appendDots || function (renderDots) {
    return /*#__PURE__*/React.createElement(CarouselDotList, Object.assign({
      dotsPosition: hasDotsPosition,
      dotsAlignment: hasDotsAlignment,
      dotsOrientation: hasDotsOrientation
    }, props), renderDots);
  };

  var checkResponsive = function checkResponsive() {
    var width = window.innerWidth;
    var currResponsive;

    if (props.responsive) {
      currResponsive = props.responsive.filter(function (item) {
        return item.breakpoint >= width;
      }).reduce(function (bestMatch, currMatch) {
        if (!bestMatch || bestMatch.breakpoint > currMatch.breakpoint) {
          return currMatch;
        }

        return bestMatch;
      }, null);
    }

    setIsVertical(_get(currResponsive, 'settings.vertical', vertical));
    setHasDots(_get(currResponsive, 'settings.dots', dots));
    setHasArrows(_get(currResponsive, 'settings.arrows', arrows));
    setHasDotsPosition(_get(currResponsive, 'settings.dotsPosition', dotsPosition));
    setHasDotsAlignment(_get(currResponsive, 'settings.dotsAlignment', dotsAlignment));
    setHasDotsOrientation(_get(currResponsive, 'settings.dotsOrientation', dotsOrientation));
  };

  useEffect(function () {
    checkResponsive();
    window.addEventListener('resize', checkResponsive);
    return function () {
      return window.removeEventListener('resize', checkResponsive);
    };
  });
  return /*#__PURE__*/React.createElement(DefaultSlider, Object.assign({}, props, {
    ref: ref,
    nextArrow: carouselArrowNext,
    prevArrow: carouselArrowPrev,
    customPaging: carouseCustomPaging,
    appendDots: customAppendDots,
    arrows: hasArrows,
    arrowSize: arrowSize,
    arrowType: arrowType,
    dotsPosition: hasDotsPosition,
    dotsAlignment: hasDotsAlignment,
    dotsOrientation: hasDotsOrientation,
    dots: hasDots,
    dotsType: dotsType,
    vertical: isVertical
  }), children);
});
Carousel.defaultProps = {
  eqHeight: false,
  children: null,
  dotsType: 'default',
  dotsPosition: 'outside bottom',
  dotsAlignment: 'center',
  dotsOrientation: 'horizontal',
  arrowSize: 'default',
  prevLabelId: 'carousel.arrow.prev.label',
  nextLabelId: 'carousel.arrow.next.label',
  accessibility: true,
  dots: true,
  arrows: true,
  arrowType: 'default',
  arrowCustomColor: null,
  infinite: true,
  initialSlide: 0,
  speed: 500,
  centerMode: false,
  centerPadding: '0',
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  pauseOnHover: true,
  adaptiveHeight: false,
  swipe: true,
  touchMove: true,
  vertical: false,
  verticalSwiping: false,
  nextArrow: null,
  prevArrow: null,
  appendDots: null,
  customPaging: null,
  rtl: false,
  responsive: null,
  lazyLoad: null,
  beforeChange: null,
  afterChange: null
};
export default Carousel;